import { useCallback, useEffect, useState } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import MenuItem from '@mui/material/MenuItem'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/default-products/product-symptoms/style'

/** API */
import ProductSymptomsApi from 'api/setting/default-products/product-symptom.api'

/** UTILS || SLICE */
import { submitModal, unSubmitModal, showModal, resetModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { swalActive } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputTextField from 'component/Input/InputTextField'
import InputTextSearch from 'component/Input/InputTextSearch'
import ModalCustom from 'component/ModalCustom/ModalCustom'
import TableCustom from 'component/Table/TableCustom'
import { notiSuccess, notiError } from 'component/notifications/notifications'
import TableRowCommon from 'component/Table/TableRowCommon'
import FilterSelect from 'component/Select/FilterSelect'
import { Box, Typography } from '@mui/material'
import AlertModal from 'new-components/modal/alert-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import PageModal from 'new-components/modal/page-modal'
import SwitchButton from 'new-components/buttons/switch-button'
import TextInput from 'new-components/inputs/text-input'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  PRODUCT_SYMPTOM_DETAIL: ``,
  IS_DUPLICATE_PRODUCT_SYMPTOM_DETAIL: ``,
  PRODUCT_SYMPTOM_DETAIL_STRING_BASE: ``,
  PRODUCT_SYMPTOM_DETAIL_STRING_EMPTY: ``,
  PRODUCT_SYMPTOM_DETAIL_MAXIMUM_LENGTH: ``,
  PRODUCT_SYMPTOM_DETAIL_ANY_REQUIRED: ``,

  PRODUCT_SYMPTOM_DETAIL_EN: ``,
  IS_DUPLICATE_PRODUCT_SYMPTOM_DETAIL_EN: ``,
  PRODUCT_SYMPTOM_DETAIL_EN_STRING_BASE: ``,
  PRODUCT_SYMPTOM_DETAIL_EN_STRING_EMPTY: ``,
  PRODUCT_SYMPTOM_DETAIL_EN_MAXIMUM_LENGTH: ``,
  PRODUCT_SYMPTOM_DETAIL_EN_ANY_REQUIRED: ``
}
export default function MedicineSymptoms() {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [productSymptoms, setProductSymptoms] = useState([])
  const [productSymptomId, setProductSymptomId] = useState(Number)
  const [detail, setProductSymptomDetail] = useState('')
  const [detailEn, setProductSymptomDetailEn] = useState('')
  const [productSymptomStatus, setProductSymptomStatus] = useState('')
  const [textLength, setTextLength] = useState<number>(0)
  const [textLengthEn, setTextLengthEn] = useState<number>(0)
  const [errorName, setErrorName] = useState<any>()
  const [errorMaxLength, setErrorMaxLength] = useState<boolean>(false)

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const [isOpenPageModal, setIsOpenPageModal] = useState(false)

  const loadData = useCallback(async () => {

    let condition: any = { group: 'MEDICINE' }
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (status) condition = { ...condition, status: status === 'ALL' ? '' : status } //fix filter status all

    const res = await ProductSymptomsApi.findAll(condition)
    if (res.status === 200) {
      setRowCount(res.headers['x-total'])
      setProductSymptoms(res.data)
    }
  }, [page, pageLimit, search, sortBy, sortType, status])

  useEffect(() => {
    loadData()
  }, [loadData])

  const submit = () => {
    if (!detail) return setErrorMessage({ ...errorMessage, ...{ PRODUCT_SYMPTOM_DETAIL: t('PRODUCT_SYMPTOM.MESSAGE.PRODUCT_SYMPTOM_DETAIL') } })

    dispatch(submitModal())

    ProductSymptomsApi.create({ detail, detailEn, group: 'MEDICINE' })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('PRODUCT_SYMPTOM.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          setIsOpenPageModal(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT_SYMPTOM.MESSAGE.${err.message}`) } })
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT_SYMPTOM.MESSAGE.${err.message}`) } })
      })
  }

  const submitEdit = () => {
    if (!detail) return setErrorMessage({ ...errorMessage, ...{ PRODUCT_SYMPTOM_DETAIL: t(`PRODUCT_SYMPTOM.MESSAGE.PRODUCT_SYMPTOM_DETAIL`) } })

    dispatch(submitModal())
    ProductSymptomsApi.update(productSymptomId, { detail, detailEn, status: productSymptomStatus, group: 'MEDICINE' })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`PRODUCT_SYMPTOM.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          setIsOpenPageModal(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT_SYMPTOM.MESSAGE.${err.message}`) } })
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT_SYMPTOM.MESSAGE.${err.message}`) } })
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }


  const handleChangeName = (e: any) => {
    setErrorName('')
    const name = e === '' ? '' : String(e)
    const contentLength = name.length

    if (contentLength > 40) {
      setErrorMaxLength(true)
    } else {
      setProductSymptomDetail(name)
      setTextLength(contentLength)
      setErrorMaxLength(false)
    }

  }
  const handleChangeNameEn = (e: any) => {
    const nameEn = e === '' ? '' : String(e)
    const contentLength = nameEn.length
    if (contentLength > 40) {
      setErrorMaxLength(true)
    } else {
      setProductSymptomDetailEn(nameEn)
      setTextLengthEn(contentLength)
      setErrorMaxLength(false)
    }
  }

  const resetForm = () => {
    setProductSymptomId(0)
    setProductSymptomDetail('')
    setProductSymptomDetailEn('')
    setProductSymptomStatus('')
    clearErrorMessage()
    setIsOpenPageModal(false)
  }

  const onActive = () => {
    if (id) {
      ProductSymptomsApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('PRODUCT_SYMPTOM.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('PRODUCT_SYMPTOM.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      ProductSymptomsApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('PRODUCT_SYMPTOM.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('PRODUCT_SYMPTOM.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { productSymptomId: pdUseId, detail: pdUseDetail, status: pdUseStatus } = data
    setProductSymptomId(pdUseId)
    setProductSymptomDetail(pdUseDetail)
    setProductSymptomDetailEn(data?.detailEn)
    setProductSymptomStatus(pdUseStatus)
    setIsOpenPageModal(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'detail', disablePadding: false, label: t('PRODUCT_SYMPTOM.TABLE.CELL.PRODUCT_SYMPTOM_DETAIL') },
    { id: 'status', disablePadding: false, label: t('PRODUCT_SYMPTOM.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('PRODUCT_SYMPTOM.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { productSymptomId: pdUseId, detail: pdUseDetail, updatedBy, updatedAt, status: pdUseStatus } = objData
    const statusBtnActive = pdUseStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = pdUseStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: pdUseId,
      id: pdUseId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: pdUseDetail },
        { option: 'STATUS', align: 'center', label: pdUseStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.detail)
    setNameEn(obj.detailEn)
  }

  return (
    <div className={classes.root}>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`PRODUCT_SYMPTOM.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`PRODUCT_SYMPTOM.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { detail: name, detailEn: nameEn && `(${nameEn})`, status: t(`PRODUCT_SYMPTOM.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        isOpen={isOpenPageModal}
        title={productSymptomId ? t('PRODUCT_SYMPTOM.TITLE_UPDATE') : t('PRODUCT_SYMPTOM.TITLE_CREATE')}
        size='XS'
        handleClose={resetForm}
        onCancel={{ onClick: resetForm, title: t('PRODUCT_SYMPTOM.BUTTON.CANCEL') }}
        onSubmit={{ onClick: productSymptomId ? submitEdit : submit, title: t('PRODUCT_SYMPTOM.BUTTON.SAVE') }}
      >
        <Box display="flex" flexDirection="column" gap="24px">
          {productSymptomId ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
            <SwitchButton onChange={() => setProductSymptomStatus(productSymptomStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={productSymptomStatus === 'ACTIVE' ? true : false} />
          </Box> : ''}
          <TextInput
            onChange={(event) => {
              handleChangeName(event.target.value)
              clearErrorMessage()
            }}
            value={detail}
            label={t('PRODUCT_SYMPTOM.INPUT.PRODUCT_SYMPTOM_DETAIL')}
            helperText={
              errorMessage.PRODUCT_SYMPTOM_DETAIL ||
              errorMessage.IS_DUPLICATE_PRODUCT_SYMPTOM_DETAIL ||
              errorMessage.PRODUCT_SYMPTOM_DETAIL_STRING_BASE ||
              errorMessage.PRODUCT_SYMPTOM_DETAIL_STRING_EMPTY ||
              errorMessage.PRODUCT_SYMPTOM_DETAIL_MAXIMUM_LENGTH ||
              errorMessage.PRODUCT_SYMPTOM_DETAIL_ANY_REQUIRED
            }
            required
          />
          <TextInput
            onChange={(event) => {
              handleChangeNameEn(event.target.value)
              clearErrorMessage()
            }}
            value={detailEn}
            label={t('PRODUCT_SYMPTOM.INPUT.PRODUCT_SYMPTOM_DETAIL_EN')}
            helperText={
              errorMessage.PRODUCT_SYMPTOM_DETAIL_EN ||
              errorMessage.IS_DUPLICATE_PRODUCT_SYMPTOM_DETAIL_EN ||
              errorMessage.PRODUCT_SYMPTOM_DETAIL_EN_STRING_BASE ||
              errorMessage.PRODUCT_SYMPTOM_DETAIL_EN_STRING_EMPTY ||
              errorMessage.PRODUCT_SYMPTOM_DETAIL_EN_MAXIMUM_LENGTH ||
              errorMessage.PRODUCT_SYMPTOM_DETAIL_EN_ANY_REQUIRED
            }
            inputProps={{ value: detailEn }}
          />
        </Box>
      </PageModal>
      <Card className="border-0 h-100">
        <HeaderCard text={t('PRODUCT_SYMPTOM.TITLE')} />
        <Card.Body>
          <Card.Title className={'mb-0 pl-xl-3'}>
            <Row className="align-items-center">
              <Col md={8}>
                <Row className="flax-row">
                  <Col sm={12} md={6} xl={4} className="pt-2">
                    <InputTextSearch
                      keyInput={'search'}
                      label={t('PRODUCT_SYMPTOM.SEARCH')}
                      value={search}
                      onchange={(event) => {
                        setSearch(event.target.value)
                        setPage(1)
                      }}
                      onClear={(event) => {
                        setSearch('')
                        setPage(1)
                      }}
                    />
                  </Col>
                  <Col sm={12} md={6} xl={4} className="pl-md-0 pt-2">
                    <FilterSelect
                      onchange={(event) => {
                        const value = event.target.value
                        if (value) {
                          handleChangeStatus(value)
                          setPage(1)
                        }
                      }}
                      renderValue={() => `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}`}
                      label={t('STATUS.LABEL')}
                      selectId="select-status"
                      value={status}
                      labelId="label-status"
                      options={[
                        <MenuItem key="1" value="ALL">
                          {t('STATUS.ALL')}
                        </MenuItem>,
                        <MenuItem key="2" value="ACTIVE">
                          {t('STATUS.ACTIVE')}
                        </MenuItem>,
                        <MenuItem key="3" value="INACTIVE">
                          {t('STATUS.INACTIVE')}
                        </MenuItem>
                      ]}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={4} className="mt-2 mt-md-auto">
                <div className="pr-xl-2">
                  <ButtonCustom mode="add" disabled={permissions.isCreate.disabled} onClick={() => setIsOpenPageModal(true)} textButton={t('PRODUCT_SYMPTOM.BUTTON.ADD')} className="w-auto ml-auto d-flex mt-auto" />
                </div>
              </Col>
            </Row>
          </Card.Title>

          <div className={'mt-3 pl-xl-3 pr-xl-2'}>
            <TableCustom
              page={page}
              pageLimit={pageLimit}
              sortType={sortType}
              sortBy={sortBy}
              onSort={onRequestSort}
              setPageLimit={handleChangeRowsPerPage}
              setPage={handleChangePage}
              rowCount={rowCount}
              headCells={headCells}
              rowsData={productSymptoms.map((val, i) => {
                return renderData(val, i)
              })}
            />
          </div>
        </Card.Body>
      </Card>

      <ModalCustom
        title={productSymptomId ? t('PRODUCT_SYMPTOM.TITLE_UPDATE') : t('PRODUCT_SYMPTOM.TITLE_CREATE')}
        size='lg'
        component={
          <div className="pb-2">
            {productSymptomId ? (
              <div>
                <Form className="mx-0 mb-3 mt-0 p-0  d-inline-flex w-100">
                  <Form.Label className=" mr-auto">{t('INPUT.LABEL_STATUS')}</Form.Label>
                  <Form.Check type="switch" id="custom-switch" onChange={() => setProductSymptomStatus(productSymptomStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={productSymptomStatus === 'ACTIVE' ? true : false} style={{ marginLeft: 'auto' }} />
                </Form>
              </div>
            ) : (
              ''
            )}
            <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${textLength}/${40}`}</Box>
            <InputTextField
              onchange={(event) => {
                handleChangeName(event.target.value)
                clearErrorMessage()
              }}
              value={detail}
              label={t('PRODUCT_SYMPTOM.INPUT.PRODUCT_SYMPTOM_DETAIL')}
              helperText={
                errorMessage.PRODUCT_SYMPTOM_DETAIL ||
                errorMessage.IS_DUPLICATE_PRODUCT_SYMPTOM_DETAIL ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_STRING_BASE ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_STRING_EMPTY ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_MAXIMUM_LENGTH ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_ANY_REQUIRED
              }
              required={true}
              style={{ marginBottom: '1rem' }}
            />
            <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${textLengthEn}/${40}`}</Box>
            <InputTextField
              onchange={(event) => {
                handleChangeNameEn(event.target.value)
                clearErrorMessage()
              }}
              value={detailEn}
              label={t('PRODUCT_SYMPTOM.INPUT.PRODUCT_SYMPTOM_DETAIL_EN')}
              helperText={
                errorMessage.PRODUCT_SYMPTOM_DETAIL_EN ||
                errorMessage.IS_DUPLICATE_PRODUCT_SYMPTOM_DETAIL_EN ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_EN_STRING_BASE ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_EN_STRING_EMPTY ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_EN_MAXIMUM_LENGTH ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_EN_ANY_REQUIRED
              }
            />
          </div>
        }
        onReset={resetForm}
        onSubmit={productSymptomId ? submitEdit : submit}
        textBtnCancel={t('PRODUCT_SYMPTOM.BUTTON.CANCEL')}
        textBtnConfirm={productSymptomId ? t('PRODUCT_SYMPTOM.BUTTON.SAVE') : t('PRODUCT_SYMPTOM.BUTTON.ADD')}
      />
    </div>
  )
}
